import { Contract } from '@/generated/gql/graphql';

export enum ContractDataGridField {
  EXTERNAL_ID = 'externalId',
  CONTRACT_ACTIVE = 'contractActive',
  CONTRACT_CREATION_DATE = 'contractCreationDate',
  CONTRACT_VALID_FROM = 'contractValidFrom',
  CONTRACT_VALID_TO = 'contractValidTo',
  CONTRACT_RECEIVED_PROPOSALS_COUNT = 'contractReceivedProposalsCount',
  CONTRACT_AVERAGE_VALUE_CONTRIBUTION = 'contractAverageValueContribution',
  SUPPLIER_NAME = 'supplierName',
  SUPPLIER_EXTERNAL_ID = 'supplierExternalId',
  SUPPLIER_EMPLOYEE_COUNT = 'supplierEmployeeCount',
  SUPPLIER_INDUSTRY = 'supplierIndustry',
  SUPPLIER_LEGAL_TYPE = 'supplierLegalType',
  SUPPLIER_ADDRESS = 'supplierAddress',
  REPRESENTATIVE_COUNT = 'representativeCount',
  CONTRACT_PRODUCT_COUNT = 'contractProductCount',
  CONTRACT_PRODUCT_CATEGORY_COUNT = 'contractProductCategoryCount',
  CONTRACT_SERVICE_COUNT = 'contractServiceCount',
  ORDER_LAST_DATE = 'orderLastDate',
  ORDER_VOLUME_YEAR = 'orderVolumeYear',
  ORDER_COUNT_YEAR = 'orderCountYear',
  PRIMARY_COMMODITY_GROUP = 'primaryCommodityGroupId',
  COMMODITY_GROUP_LIST = 'commodityGroupList',
  COMMODITY_GROUP_COUNT = 'commodityGroupCount',
  LINKS = 'links',
}

export enum ContractDataGridColumnGroup {
  SUPPLIER = 'supplier',
  CONTRACT = 'contract',
  PRODUCT = 'product',
  SERVICE = 'service',
  ORDER = 'order',
}

export type ContractDataGridRow = Contract;
